var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyProspectsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 166,
    viewBox: "0 0 189 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8351 165.9C94.7888 165.826 93.6999 164.012 93.3215 160.249C92.9754 156.796 93.1988 150.975 96.2279 142.856C101.964 127.476 94.9056 115.067 94.8331 114.942L95.1813 114.742C95.1994 114.772 97.0209 117.937 98.0977 122.966C99.5233 129.65 99.0074 136.6 96.6103 143.001C90.8821 158.355 95.141 165.623 95.1853 165.695L94.8351 165.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5909 114.044C94.036 114.044 95.2074 112.876 95.2074 111.436C95.2074 109.995 94.036 108.828 92.5909 108.828C91.1458 108.828 89.9744 109.995 89.9744 111.436C89.9744 112.876 91.1458 114.044 92.5909 114.044Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.843 123.672C102.288 123.672 103.46 122.505 103.46 121.065C103.46 119.624 102.288 118.457 100.843 118.457C99.398 118.457 98.2266 119.624 98.2266 121.065C98.2266 122.505 99.398 123.672 100.843 123.672Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2075 130.092C96.6525 130.092 97.824 128.924 97.824 127.484C97.824 126.044 96.6525 124.876 95.2075 124.876C93.7624 124.876 92.5909 126.044 92.5909 127.484C92.5909 128.924 93.7624 130.092 95.2075 130.092Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.051 135.508C103.496 135.508 104.667 134.341 104.667 132.9C104.667 131.46 103.496 130.292 102.051 130.292C100.606 130.292 99.4342 131.46 99.4342 132.9C99.4342 134.341 100.606 135.508 102.051 135.508Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1948 143.933C94.6398 143.933 95.8113 142.766 95.8113 141.326C95.8113 139.885 94.6398 138.718 93.1948 138.718C91.7497 138.718 90.5782 139.885 90.5782 141.326C90.5782 142.766 91.7497 143.933 93.1948 143.933Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2158 91.7844H32.8132V142.12H33.2158V91.7844Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4934 84.0391H45.0908V149.865H45.4934V84.0391Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7709 81.8464H57.3684V152.058H57.7709V81.8464Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0485 84.0391H69.646V149.865H70.0485V84.0391Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.326 91.7844H81.9235V142.12H82.326V91.7844Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5857 100.102H26.5538V100.503H88.5857V100.102Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7922 116.752H22.3472V117.153H92.7922V116.752Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5857 133.402H26.5538V133.803H88.5857V133.402Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.777 106.503C163.23 106.503 179 90.7854 179 71.397C179 52.0086 163.23 36.2913 143.777 36.2913C124.325 36.2913 108.555 52.0086 108.555 71.397C108.555 90.7854 124.325 106.503 143.777 106.503Z",
    fill: "#D14358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2011 58.4841H93.7986V108.82H94.2011V58.4841Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.479 50.7388H106.076V116.565H106.479V50.7388Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.756 48.5461H118.354V118.758H118.756V48.5461Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.034 50.7388H130.631V116.565H131.034V50.7388Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.311 58.4841H142.909V108.82H143.311V58.4841Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.571 66.8013H87.5391V67.2025H149.571V66.8013Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.777 83.4514H83.3324V83.8526H153.777V83.4514Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.571 100.102H87.5391V100.503H149.571V100.102Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.781 6.63599C136.092 6.63599 128.236 15.3242 128.236 26.0404L128.236 47H133.5L134.5 39V46.5L161 42L162.929 37.5L162.5 41.5L165.968 42V28.9652C165.968 16.6341 156.931 6.63599 145.781 6.63599Z",
    fill: "#112EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.312 31.1077C137.312 31.1077 142.788 43.8421 135.488 46.3897L142.788 70.4121L155.201 69.6839L158.485 61.6798L157.755 49.6716L156.66 41.6675C156.66 41.6675 148.993 43.487 149.724 30.0325L137.312 31.1077Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.393 46.0266C134.393 46.0266 122.345 44.9353 123.44 53.6656C124.535 62.3959 125.632 64.2174 125.632 64.2174L126.727 77.3168L120.159 81.3189H113.95C113.95 81.3189 94.966 85.684 104.46 90.4143C113.954 95.1445 117.237 86.7753 117.237 86.7753C117.237 86.7753 134.759 86.7753 135.854 83.8645C136.949 80.9538 134.393 46.0266 134.393 46.0266Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.755 42.3877C157.755 42.3877 169.072 38.3756 169.803 47.1179C170.533 55.8603 170.531 56.5704 170.531 56.5704L172.723 68.9417C172.723 68.9417 177.103 79.8565 177.103 83.1324C177.103 86.4083 180.387 96.593 180.387 96.593C180.387 96.593 184.769 110.784 180.023 110.421C175.277 110.058 174.547 95.1386 174.547 95.1386L164.684 75.4914L161.764 63.4832L157.755 42.3877Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.216 44.5702H133.296L132.932 59.8522C132.932 59.8522 128.186 66.3999 134.027 72.2175L135.488 81.678L162.136 80.5867L163.962 70.7571C163.962 70.7571 167.611 62.753 162.501 55.475L157.755 40.5581H155.2C155.2 40.5581 161.118 62.3076 148.629 62.753C138.408 63.1261 136.216 44.5702 136.216 44.5702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.608 134.922C170.377 144.153 160.353 151.623 149.142 156.883C149.142 138.676 149.354 123.887 149.354 123.887C149.354 123.887 147.804 139.514 145.835 158.353C134.59 163.085 122.504 165.515 110.297 165.498C110.079 165.498 109.862 165.498 109.645 165.498C119.688 129.53 134.339 88.306 134.743 87.1686C134.744 87.1606 134.744 87.1525 134.743 87.1445L135.627 84.2076L136.003 82.9579L136.406 81.6479L136.941 79.8666L160.669 79.1404L161.333 80.6269L163.589 85.6881C163.787 85.7446 163.973 85.8319 164.143 85.9469C168.42 88.7373 173.804 110.066 178.608 134.922Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.231 76.2295L134.393 77.3208C134.393 77.3208 133.077 87.1504 134.393 87.1504C134.757 87.1504 164.691 89.6961 164.326 85.3309C163.962 80.9658 163.231 76.2295 163.231 76.2295Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.955 35.2764C148.62 35.2764 153.212 30.6995 153.212 25.0536C153.212 19.4077 148.62 14.8308 142.955 14.8308C137.29 14.8308 132.698 19.4077 132.698 25.0536C132.698 30.6995 137.29 35.2764 142.955 35.2764Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.768 11.9799C149.007 9.72113 146.409 8.28882 143.509 8.28882H143.164C136.522 8.28882 131.14 14.2769 131.14 21.6651H133.364L133.725 18.9369L134.248 21.6651H147.447L148.552 19.3582L148.279 21.6651H150.875C152.083 27.6605 149.696 38.5019 145 44.5L149 46.5L151.5 41L151 46.5L160 46L161.822 29.0473C161.822 21.1014 157.193 14.3631 150.768 11.9799Z",
    fill: "#2F49D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.453 84.1588C108.745 82.3642 107.523 80.6732 105.722 80.3819C103.921 80.0906 102.225 81.3093 101.933 83.1039C101.64 84.8985 102.863 86.5894 104.664 86.8807C106.464 87.172 108.161 85.9534 108.453 84.1588Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.189 83.6279H33.1696V54.6526H93.076L105.189 83.6279Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4256 54.9833C59.1325 56.0879 59.1323 58.5853 57.4253 59.6896L54.6737 61.4697C53.9952 61.9087 53.1 61.4216 53.1 60.6134C53.1 60.2675 53.2754 59.9451 53.5659 59.7572L54.128 59.3935C55.6203 58.4281 55.6207 56.2449 54.1287 55.279L53.5656 54.9144C53.2753 54.7265 53.1 54.4043 53.1 54.0584C53.1 53.2503 53.9953 52.7632 54.6738 53.2023L57.4256 54.9833Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1234 54.9833C60.8302 56.0879 60.83 58.5853 59.123 59.6896L56.3715 61.4697C55.693 61.9087 54.7978 61.4216 54.7978 60.6134C54.7978 60.2675 54.9731 59.9451 55.2636 59.7572L55.8258 59.3935C57.3181 58.4281 57.3184 56.2449 55.8265 55.279L55.2633 54.9144C54.973 54.7265 54.7978 54.4043 54.7978 54.0584C54.7978 53.2503 55.693 52.7632 56.3715 53.2023L59.1234 54.9833Z",
    stroke: "#7788E3",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6415 54.9833C60.9347 56.0879 60.9349 58.5853 62.6419 59.6896L65.3934 61.4697C66.0719 61.9087 66.9671 61.4216 66.9671 60.6134C66.9671 60.2675 66.7917 59.9451 66.5013 59.7572L65.9391 59.3935C64.4468 58.4281 64.4465 56.2449 65.9384 55.279L66.5016 54.9144C66.7919 54.7265 66.9671 54.4043 66.9671 54.0584C66.9671 53.2503 66.0718 52.7632 65.3934 53.2023L62.6415 54.9833Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9439 54.9833C59.237 56.0879 59.2372 58.5853 60.9442 59.6896L63.6958 61.4697C64.3743 61.9087 65.2695 61.4216 65.2695 60.6134C65.2695 60.2675 65.0941 59.9451 64.8036 59.7572L64.2415 59.3935C62.7492 58.4281 62.7488 56.2449 64.2408 55.279L64.8039 54.9144C65.0942 54.7265 65.2695 54.4043 65.2695 54.0584C65.2695 53.2503 64.3742 52.7632 63.6957 53.2023L60.9439 54.9833Z",
    stroke: "#7788E3",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.517 83.8527H24.3539V48.2876H90.7936L90.85 48.422L105.517 83.8527ZM24.8067 83.4154H104.863L90.5058 48.7269H24.8007L24.8067 83.4154Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 66H29V69H59V66Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 71H29V74H59V71Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 76H29V79H59V76Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 66H63V69H93V66Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 71H63V74H93V71Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 76H63V79H93V76Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41526 117.624C1.93757 117.624 1.4706 117.483 1.07341 117.219C0.676226 116.954 0.366657 116.578 0.183852 116.138C0.0010465 115.698 -0.0467837 115.214 0.0464096 114.747C0.139603 114.28 0.369634 113.852 0.707414 113.515C1.04519 113.178 1.47555 112.949 1.94407 112.856C2.41258 112.763 2.89821 112.811 3.33954 112.993C3.78087 113.175 4.15808 113.484 4.42347 113.88C4.68887 114.276 4.83052 114.741 4.83052 115.217C4.83052 115.856 4.57605 116.468 4.1231 116.919C3.67016 117.371 3.05583 117.624 2.41526 117.624ZM2.41526 113.211C2.01718 113.211 1.62804 113.329 1.29705 113.549C0.966065 113.77 0.708091 114.083 0.555753 114.449C0.403415 114.816 0.363557 115.219 0.441218 115.608C0.518879 115.998 0.710571 116.355 0.992055 116.636C1.27354 116.916 1.63217 117.107 2.0226 117.185C2.41303 117.262 2.81772 117.222 3.18549 117.07C3.55327 116.919 3.86761 116.661 4.08877 116.332C4.30993 116.002 4.42797 115.614 4.42797 115.217C4.42797 114.685 4.21592 114.175 3.83846 113.799C3.46101 113.422 2.94906 113.211 2.41526 113.211Z",
    fill: "#2F49D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3176 27.0095H83.3445V23.0476H87.3176V27.0095ZM83.6504 26.7046H87.0116V23.3525H83.6504V26.7046Z",
    fill: "#5066D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1708 27.8279L9.45972 24.9311L12.3641 22.229L15.0752 25.1257L12.1708 27.8279ZM9.89245 24.9452L12.1869 27.3966L14.6445 25.1117L12.352 22.6683L9.89245 24.9452Z",
    fill: "#A0AEC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8316 155.332C93.4405 158.56 92.3582 161.298 89.8993 163.285C89.8423 163.332 89.7847 163.377 89.7272 163.421C89.6114 163.511 89.4941 163.597 89.3766 163.68C87.0352 165.323 84.3537 165.532 81.9275 162.53C79.4171 159.425 80.372 152.173 80.4477 151.631C80.4503 151.61 80.4521 151.599 80.4521 151.599C80.4521 151.599 88.223 152.106 90.8316 155.332Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1431 163.083L89.0723 159.52L89.3333 163.328L89.5322 163.582C89.4114 163.676 89.2892 163.766 89.1668 163.853L86.7396 160.476L86.7179 160.452L86.7174 160.445L86.4881 160.125L82.8104 159.07L86.3083 159.892L86.3649 159.954L84.5308 157.402L81.0333 156.066L84.2028 156.96L80.2577 151.785L80.2441 151.767L80.2578 151.784L83.4583 155.792L83.6357 153.034L83.73 156.141L85.4574 158.356L85.1222 155.161L85.7118 158.682L86.6722 159.914L86.286 155.401L87.007 160.344L89.1431 163.083Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.559 156.681C102.175 159.595 100.241 160.376 98.0207 160.084C97.9692 160.077 97.9179 160.069 97.867 160.062C97.7644 160.046 97.6629 160.028 97.5631 160.008C95.5768 159.608 94.1608 158.333 94.5176 155.622C94.8868 152.818 99.0762 149.768 99.3913 149.543C99.4034 149.534 99.41 149.529 99.41 149.529C99.41 149.529 102.943 153.766 102.559 156.681Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7555 159.597L99.5507 157.821L97.723 159.814L97.6893 160.04C97.5822 160.024 97.4762 160.005 97.372 159.985L97.9212 157.09L97.923 157.067L97.9263 157.064L97.9784 156.79L96.7255 154.386L98.0102 156.584L98.0064 156.643L98.4212 154.456L97.4 152.008L98.4883 154.072L99.2198 149.52L99.2223 149.505L99.2202 149.52L98.7244 153.119L100.227 151.864L98.6782 153.429L98.3837 155.397L99.8608 153.665L98.3405 155.687L98.1768 156.781L100.305 154.38L98.1195 157.163L97.7555 159.597Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 61.2462,
    y1: 56.9254,
    x2: 53,
    y2: 56.9254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 58.8209,
    y1: 56.9254,
    x2: 67.0671,
    y2: 56.9254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7788E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#758AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 166,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.24625,
    height: 10.6716,
    fill: "white",
    transform: "translate(54.6978 52)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.24625,
    height: 10.6716,
    fill: "white",
    transform: "matrix(-1 0 0 1 67.0671 52)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.24625,
    height: 10.6716,
    fill: "white",
    transform: "matrix(-1 0 0 1 65.3695 52)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProspectsList);
export default __webpack_public_path__ + "static/media/emptyProspectsList.4e5cf603.svg";
export { ForwardRef as ReactComponent };